import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { validateRequestViewForm } from './validaterequestview';
import * as caseActions from '../../actions/caseActions';
import * as logoutAction from '../../actions/logoutAction';
import * as loginActions from '../../actions/loginActions';
import { ThemeProvider } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
  Box,
  Typography,
  Button,
  TextField,
  MenuItem,
  Stack,
  Grid,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@mui/material';
import appTheme from '../../components/apptheme';
import { ReactComponent as BCHLogoSOP } from '../../images/BCH-logo-SOP.svg';
import BadgeIcon from '@mui/icons-material/Badge';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import Pageview from '@mui/icons-material/Pageview';
import DriveFolderUploadRounded from '@mui/icons-material/DriveFolderUploadRounded';
import Tooltip from '@mui/material/Tooltip';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Footer from '../../components/footer';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import RequestViewMessage from '../message/requestviewmessage';
import CaseExistMessage from '../message/caseexistmessage';
import { GENDER } from '../../config/gender';

export default function RequestView() {
  console.log('Case: - Case page loading...');
  let navigate = useNavigate();
  // redux
  const dispatch = useDispatch();
  const st = useSelector((state) => state.rootReducer);
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [showCaseAccessRequested, setShowCaseAccessRequested] = useState(false);
  const [showCaseAlreadyLinked, setShowCaseAlreadyLinked] = useState(false);
  const [accessCaseSubmitted, setAccessCaseSubmitted] = useState(false);

  const detectMobileType = () =>
    /iPhone|iPad|iPod/i.test(navigator.userAgent)
      ? 'iPhone'
      : /Android/i.test(navigator.userAgent)
      ? 'Android'
      : 'Desktop';

  const onMobile = detectMobileType() !== 'Desktop';
  React.useEffect(() => {
    if (accessCaseSubmitted && !st.isAccessCaseLoading && st.createcaseerror === '') {
      if (st.returnCode === 202) setShowCaseAccessRequested(true);
      else if (st.returnCode === 206) setShowCaseAlreadyLinked(true);
      else setAccessCaseSubmitted(false);
    }
  }, [accessCaseSubmitted, st.isAccessCaseLoading, st.returnCode]);

  // step 2
  const dateToString = (dt) => {
    // Parse date without timezone
    if (dt === null) {
      dt = new Date();
    }
    try {
      var date_to_convert = new Date(
        dt.getUTCFullYear(),
        dt.getUTCMonth(),
        dt.getUTCDate(),
        10,
        0,
        0,
        0
      );
      return date_to_convert.toDateString().slice(4);
    } catch (error) {
      console.log(error);
      return new Date().toDateString().slice(4);
    }
  };
  const handleRequestView = (values) => {
    console.log(values);
    var accessRequest = {
      email: st.userDetail.email,
      patientFirstName: values.firstName,
      patientLastName: values.lastName,
      patientDob: values.dob,
      gender: values.gender
    };
    dispatch(caseActions.requestAccessCase(accessRequest));
    setAccessCaseSubmitted(true);
  };

  const formikRequestView = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: st !== undefined && st.patient.firstName !== '' ? st.patient.firstName : '',
      lastName: st !== undefined && st.patient.lastName !== '' ? st.patient.lastName : '',
      dob:
        st !== undefined &&
        st.patient !== undefined &&
        st.patient.dob !== null &&
        st.patient.dob !== '' &&
        st.patient.dob !== undefined
          ? dateToString(new Date(st.patient.dob))
          : '',
      gender: st !== undefined ? st.patient.gender : ''
    },
    validationSchema: validateRequestViewForm,
    onSubmit: (values) => {
      handleRequestView(values);
    }
  });

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleViewCasesNavMenu = () => {
    // reset error when navigate out
    if (
      st.createcaseerror !== '' ||
      st.updatebasicerror !== '' ||
      st.updatecontacterror !== '' ||
      st.updatemderror !== '' ||
      st.updatebcherror !== ''
    )
      dispatch(loginActions.clearError());
      
    navigate('/sop2web/home');
  };

  const handleNewCaseNavMenu = () => {
    dispatch(caseActions.clearCase());
    dispatch(caseActions.setShowWelcome(false));
    // reset error when navigate out
    if (
      st.createcaseerror !== '' ||
      st.updatebasicerror !== '' ||
      st.updatecontacterror !== '' ||
      st.updatemderror !== '' ||
      st.updatebcherror !== ''
    )
      dispatch(loginActions.clearError()); 
    
    navigate('/sop2web/newcase');
  };
  const handleProfileNavMenu = () => {
    // reset error when navigate out
    if (
      st.createcaseerror !== '' ||
      st.updatebasicerror !== '' ||
      st.updatecontacterror !== '' ||
      st.updatemderror !== '' ||
      st.updatebcherror !== ''
    )
      dispatch(loginActions.clearError());
    
    navigate('/sop2web/profile');

  };

  const handleLogoutNavMenu = () => {
    dispatch(logoutAction.logOut());
    navigate('/sop2web/signin');
  };

  const handleCancel = () => {
    if (
      st.createcaseerror !== '' ||
      st.updatebasicerror !== '' ||
      st.updatecontacterror !== '' ||
      st.updatemderror !== '' ||
      st.updatebcherror !== ''
    )
      dispatch(loginActions.clearError());
    navigate('/sop2web/home');
  };

  return (
    <ThemeProvider theme={appTheme}>
      <AppBar position="static" style={{ background: '#003087', height: 80 }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ mr: 2, display: { xs: 'none', md: 'none', lg: 'flex' } }}>
              <BCHLogoSOP />
            </Typography>

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', lg: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit">
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left'
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left'
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: 'block', md: 'none' }
                }}>
                <MenuItem key="View My Cases" onClick={handleViewCasesNavMenu}>
                  <BadgeIcon style={{ fill: '#003087' }} sx={{ fontSize: 50 }} />
                  <Typography textAlign="center">View My Cases</Typography>
                </MenuItem>
                <MenuItem key="Request New Case" onClick={handleNewCaseNavMenu}>
                  <CreateNewFolderIcon style={{ fill: '#003087' }} sx={{ fontSize: 50 }} />
                  <Typography textAlign="center">Request New Case</Typography>
                </MenuItem>
                <MenuItem key="Request to View" onClick={handleNewCaseNavMenu}>
                  <Pageview style={{ fill: '#003087' }} sx={{ fontSize: 50 }} />
                  <Typography textAlign="center">Request to View</Typography>
                </MenuItem>
                {false && (
                  <MenuItem key="Upload File">
                    <DriveFolderUploadRounded style={{ fill: '#003087' }} sx={{ fontSize: 50 }} />
                    <Typography textAlign="center">Upload File</Typography>
                  </MenuItem>
                )}
              </Menu>
            </Box>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex', lg: 'none' } }}>
              <BCHLogoSOP />
            </Typography>
            <Box
              sx={{ flexGrow: 1, display: { xs: 'none', md: 'none', lg: 'flex' }, gap: 4, ml: 3 }}>
              <Button
                key="View My Cases"
                onClick={handleViewCasesNavMenu}
                size="iconSizeLarge"
                startIcon={<BadgeIcon />}
                sx={{ my: 2, color: 'white' }}>
                View My Cases
              </Button>
              <Button
                key="Request New Case"
                onClick={handleNewCaseNavMenu}
                size="iconSizeLarge"
                startIcon={<CreateNewFolderIcon />}
                sx={{ my: 0, color: 'white' }}>
                Request New Case
              </Button>
              <Button
                key="Request to View"
                size="iconSizeLarge"
                onClick={handleNewCaseNavMenu}
                startIcon={<Pageview />}
                sx={{ my: 0, color: 'white' }}>
                Request to View
              </Button>
              {false && (
                <Button
                  key="Upload File"
                  size="iconSizeLarge"
                  onClick={handleNewCaseNavMenu}
                  startIcon={<DriveFolderUploadRounded />}
                  sx={{ my: 0, color: 'white' }}>
                  Upload File
                </Button>
              )}
            </Box>
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Click to open menu">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <AccountCircle style={{ fill: '#FFFFFF' }} sx={{ fontSize: 50 }} />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}>
                <MenuItem key="Profile" onClick={handleProfileNavMenu}>
                  <Typography textAlign="center">Profile</Typography>
                </MenuItem>
                <MenuItem key="Logout" onClick={handleLogoutNavMenu}>
                  <Typography textAlign="center">Logout</Typography>
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Grid container component="main" sx={styles.gridContainerStyle}>
        {/* <CssBaseline /> */}
        {/* <PerfectScrollbar component="div"> */}
        {showCaseAccessRequested === false && showCaseAlreadyLinked === false && (
          <Grid item xs={12} md={12} lg={12} sx={styles.contentStyle}>
            <Box sx={styles.formCardContainerStyle}>
              <Stack direction="row" sx={{ mt: 5 }}>
                <Pageview color="primary" style={{ fontSize: 50 }} />
                <Typography sx={{ my: 1, fontSize: 20, fontWeight: '700' }}>
                  Request to View Case
                </Typography>
              </Stack>
              <Box sx={styles.containerStyle}>
                <Box component="form" noValidate>
                  <Typography sx={styles.subTitleStyle}>Who is the second opinion for?</Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      // alignItems: 'center',
                      justifyContent: 'flex-start',
                      border: 0,
                      mt: 0,
                      width: 400
                    }}>
                    <TextField
                      // size="small"
                      // variant="standard"
                      margin="dense"
                      required
                      fullWidth
                      id="firstName"
                      label="Patient's first name"
                      name="firstName"
                      autoComplete="firstName"
                      inputProps={{ style: { fontSize: 16 } }}
                      InputLabelProps={{ style: { fontSize: 14 } }}
                      autoFocus
                      value={formikRequestView.values.firstName}
                      onChange={formikRequestView.handleChange}
                      error={
                        formikRequestView.touched.firstName &&
                        Boolean(formikRequestView.errors.firstName)
                      }
                      helperText={
                        formikRequestView.touched.firstName && formikRequestView.errors.firstName
                      }
                    />
                    <TextField
                      margin="dense"
                      required
                      fullWidth
                      id="lastName"
                      label="Patient's last name"
                      name="lastName"
                      autoComplete="lastName"
                      inputProps={{ style: { fontSize: 16 } }}
                      InputLabelProps={{ style: { fontSize: 14 } }}
                      value={formikRequestView.values.lastName}
                      onChange={formikRequestView.handleChange}
                      error={
                        formikRequestView.touched.lastName &&
                        Boolean(formikRequestView.errors.lastName)
                      }
                      helperText={
                        formikRequestView.touched.lastName && formikRequestView.errors.lastName
                      }
                    />
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <Box sx={{ mt: 2 }}>
                        {!onMobile && (
                          <DatePicker
                            openTo="year"
                            views={['year', 'month', 'day']}
                            floatingLabelText="Date"
                            label="Patient's date of birth"
                            size="small"
                            id="dob"
                            maxDate={new Date()}
                            value={formikRequestView.values.dob}
                            onChange={(newvalue) =>
                              formikRequestView.setFieldValue('dob', dateToString(newvalue))
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                fullWidth
                                // name="dob"
                                inputProps={{ style: { fontSize: 16 } }}
                                InputLabelProps={{ style: { fontSize: 14 } }}
                                value={formikRequestView.values.dob}
                                onChange={(value) =>
                                  formikRequestView.setFieldValue('dob', dateToString(value))
                                }
                                error={
                                  formikRequestView.touched.dob &&
                                  Boolean(formikRequestView.errors.dob)
                                }
                                helperText={
                                  formikRequestView.touched.dob && formikRequestView.errors.dob
                                }
                              />
                            )}
                          />
                        )}
                        {onMobile && (
                          /*<TextField
                            id="date"
                            label="Date of birth"
                            type="date"
                            required
                            fullWidth
                            inputProps={{ style: { fontSize: 16 } }}
                            InputLabelProps={{ style: { fontSize: 14 } }}
                            maxDate={new Date()}
                            value={formikRequestView.values.dob}
                            // onChange={(value) => formikRequestView.setFieldValue('dob', value)}
                            onChange={formikRequestView.handleChange}
                            error={formikRequestView.touched.dob && Boolean(formikRequestView.errors.dob)}
                            helperText={formikRequestView.touched.dob && formikRequestView.errors.dob}
                          />*/
                          <DatePicker
                            views={['day']}
                            label="Date of birth"
                            maxDate={new Date()}
                            value={formikRequestView.values.dob}
                            onChange={(newValue) => {
                              formikRequestView.setFieldValue('dob', newValue);
                            }}
                            renderInput={(params) => (
                              <TextField {...params} required fullWidth helperText={'mm/dd/yyyy'} />
                            )}
                          />
                        )}
                      </Box>
                    </LocalizationProvider>
                    <Box sx={{ mb: 0, mt: 2 }}>
                      <FormControl>
                        <FormLabel id="gender-group">
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 16,
                              textAlign: 'left'
                            }}>
                            Gender&#x2a;
                          </Typography>
                        </FormLabel>
                        <RadioGroup
                          row
                          aria-labelledby="gender"
                          name="gender"
                          id="gender"
                          value={formikRequestView.values.gender}
                          onChange={formikRequestView.handleChange}>
                          {GENDER.map((res) => {
                            return (
                              <Box key={res.key}>
                                <FormControlLabel
                                  value={res.value}
                                  control={<Radio />}
                                  label={
                                    <Typography
                                      style={{
                                        color: '#021D4E',
                                        fontWeight: '500',
                                        fontSize: 18,
                                        textAlign: 'left'
                                      }}>
                                      {res.text}
                                    </Typography>
                                  }
                                />
                              </Box>
                            );
                          })}
                        </RadioGroup>

                        {formikRequestView.touched.gender &&
                          Boolean(formikRequestView.errors.gender) && (
                            <Typography style={styles.errorText}>
                              {formikRequestView.errors.gender}
                            </Typography>
                          )}
                      </FormControl>
                    </Box>
                    <Typography style={styles.errorText}>{st.createcaseerror}</Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      mt: 2,
                      border: 0,
                      width: 400
                    }}>
                    <Button size="large" variant="contained" sx={{ mb: 5 }} onClick={handleCancel}>
                      Cancel
                    </Button>
                    <Button
                      size="large"
                      variant="contained"
                      onClick={formikRequestView.handleSubmit}
                      sx={{ mb: 5 }}>
                      Request
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        )}
        {showCaseAccessRequested === true && showCaseAlreadyLinked === false && (
          <RequestViewMessage />
        )}
        {showCaseAlreadyLinked === true && showCaseAccessRequested === false && (
          <CaseExistMessage />
        )}
        <Footer />
      </Grid>
    </ThemeProvider>
  );
}

const styles = {
  gridContainerStyle: {
    height: '93vh',
    backgroundColor: '#EDF3FC'
  },
  contentStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    // minWidth: 600,
    border: 0,
    my: 8
  },
  formCardContainerStyle: {
    display: 'flex',
    border: 0,
    boxShadow: 1,
    borderColor: '#747678',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 600,
    background: '#FFFF'
  },
  subTitleStyle: {
    display: 'flex',
    justifyContent: 'left',
    my: 1,
    fontSize: 18,
    fontWeight: '500'
  },
  containerStyle: {
    my: 0,
    mx: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    border: 0,
    width: 400
  },
  errorText: {
    color: '#d32f2f',
    fontWeight: 'normal',
    fontSize: 16,
    marginBottom: 10,
    marginTop: 0,
    textAlign: 'left',
    marginLeft: 0
  },
  linkItemStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    border: 0,
    mt: 2,
    mb: 4
  },
  linkTextStyle: {
    color: '#003087'
  },
  inputRoot: {
    fontSize: 20
  },
  labelRoot: {
    fontSize: 20,
    color: 'red',
    '&$labelFocused': {
      color: 'purple'
    }
  },
  labelFocused: {}
};
